const ResetPasswordResultTypes = Object.freeze({
  SUCCESS: 1,
  INVALID_EMAIL_ADDRESS: 2,
  DEACTIVE_USER: 3,
});

export default ResetPasswordResultTypes;
